<template>
  <div class="about">
		<div class="pg-header">
			<div><label class="title">待续签</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>签约管理</span>|
					<span>待续签</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<el-tabs class="customize" v-model="filter.schedulingState">
				<el-tab-pane label="待续签" name="1"></el-tab-pane>
			</el-tabs>
					
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name" @keyup.enter.native="handleFilter(0, $event)"></el-input></label>
						<label>身份证号<el-input size="small" maxlength="18" style="width:150px" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						
						<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<!-- <div class="action-bar">
					<el-popconfirm confirmButtonText='确定' title="确定勿访吗？" @confirm="saveForm">
						<el-button slot="reference" type="danger" size="mini" round plain>批量勿访</el-button>
					</el-popconfirm>
				</div> -->
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
					<el-table-column prop="name" label="姓名" width="120">
						<template slot-scope="scope"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2}}"><span class="fc key"><i class="icon-fav small" v-if="scope.row.star == 1"></i>{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column label="性别" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-else>女</span>
						</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column>
					<el-table-column prop="cardNum" label="身份证号" width="180"></el-table-column>
					<el-table-column prop="signStartTime" label="开始服务时间"  width="120"></el-table-column>
					<el-table-column prop="signEndTime" label="结束服务时间" width="120"></el-table-column>
					<el-table-column prop="signServiceDay" label="剩余服务天数"></el-table-column>
					<el-table-column prop="signUserName" label="签约人" width="160"></el-table-column>
					<el-table-column prop="date" label="签约时间" width="180"></el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2}}"><i class="icon-research"></i></router-link></el-tooltip>
								<!-- <el-tooltip content="排期" placement="top" :enterable="false"><i class="icon-schedule" @click="scope"></i></el-tooltip> -->

								<el-tooltip content="修改" placement="top" :enterable="false">
									<i class="icon-edit"  @click="showDlg(scope.row)"></i>
								</el-tooltip>

								<el-popconfirm confirmButtonText='回退' title="确定回退到待签约吗？" @confirm="saveForm2(scope.row)">
									<el-tooltip content="回退" slot="reference" placement="top" :enterable="false">
										<i class="icon-sync"></i>
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				

			<el-dialog title="修改" width="560px" center :visible.sync="dlg.active" :close-on-click-modal="false">
				<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
					<el-form-item label="修改周期：" prop="period">
						<el-date-picker type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy/MM/dd" v-model="form.period"></el-date-picker>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" :loading="isLoading" @click="saveForm">保存</el-button>
				</div>
			</el-dialog>

		</div>

  </div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					period: {required: true, message: '请选择', trigger: 'change'}
				}
			},			
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				signState: 2,
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				id: 0,
				period: undefined,
			},			
			deptList: [],
		}
	},
	created() {
		let name=localStorage.getItem('reName');
		let cardNum=localStorage.getItem('reCardNum');
		if(name||cardNum){
			this.filter.name=name;
			this.filter.cardNum=cardNum;
			this.handleFilter()
		}else{
			this.loadList()
		}
	},	
	mounted() {
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable)  
	},  
	destroyed() { 
		localStorage.removeItem('reName');
		localStorage.removeItem('reCardNum'); 
		document.removeEventListener('visibilitychange', this.handleVisiable)  
	},  
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getContractList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
					item.signStartTime = dayjs(item.signStartTime).format('YYYY-MM-DD');
					item.signEndTime = dayjs(item.signEndTime).format('YYYY-MM-DD');
					item.cardNum = utils.hideIdCard(item.cardNum);
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		// 签约
		async saveForm() {
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					let res, postForm;
					this.isLoading = true;
					postForm = {
						signStartTime: this.form.period[0],
						signEndTime: this.form.period[1],
						patientId: this.form.patientId,
					}
					
					res = await api.setContractSigned(postForm);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}

					this.$message.success('签约成功');
					this.closeDlg();
					this.loadList();
				}	
			});
		},
		async saveForm2(item) {
				this.isLoading = true;
				let res = await api.setContractBack({patientId: item.patientId});
				this.isLoading = false;
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.$message.success('操作成功');
				this.loadList();			
		},
		showDlg(item) {
			this.dlg.active = true;
			this.$nextTick(()=>{
				this.$refs['form'].resetFields();
				this.form.patientId = item.patientId;
			});			
		},
		closeDlg() {
			this.dlg.active = false;
		},		
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},
		getUser() {
			return JSON.parse(localStorage.getItem('user')).data;
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		handleVisiable(e){
			console.log(e.target.visibilityState)
			// 关闭新开页面，回到列表页，刷新列表数据
			if(e.target.visibilityState == "visible"){
				this.loadList()
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.user-not-found {
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 2;
	i {
		margin-right: 5px;
	}
}
.def-key{
	.el-checkbox{
		font-weight:400 ;
		color: #808080;
	}
}
</style>
